import styled from 'styled-components';

export const ButtonContainer = styled.div`
  height: 6rem;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 4rem;
`;
